import { Button } from "@/components/ui/button";

interface DiaryTabHeaderProps {
  canAddVisita: boolean;
  onAddVisita: () => void;
  addVisitaLoading?: boolean;
}

export default function DiaryTabHeader({
  canAddVisita,
  onAddVisita,
  addVisitaLoading = false,
}: DiaryTabHeaderProps) {
  if (!canAddVisita) return null;

  return (
    <div className="flex justify-end">
      <Button
        type="button"
        onClick={onAddVisita}
        disabled={addVisitaLoading}
      >
        {addVisitaLoading ? "ADICIONANDO..." : "ADICIONAR VISITA"}
      </Button>
    </div>
  );
}
